import {Component, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild, EventEmitter} from '@angular/core';
import {
    AbstractControl, ControlValueAccessor,
    UntypedFormBuilder,
    UntypedFormGroup,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ValidationErrors
} from "@angular/forms";
import {
    MatAutocompleteSelectedEvent,
    MatAutocompleteTrigger
} from "@angular/material/autocomplete";
import {Observable, Subscription} from "rxjs";
import {debounceTime, map, startWith} from "rxjs/operators";
import {arrayIsSet, isValidNumber, stringIsSet} from "../../providers/service/global-variables.service";
import {TranslateService} from "@ngx-translate/core";
import {isNotNullOrUndefined} from "../../providers/service/global-variables.service";
import {MatFormFieldAppearance} from "@angular/material/form-field";


export interface dataForm {
    valueForm: string;
    html: string;
    registerValue?: any;
    traduction?: string | undefined;
    sensorEventTraduction?: string;
    traductions?: string[] | undefined;
    icon?: { color: string, iconName: string, svgName: string };
}

export interface GroupDataForm {
    groupName: string;
    possibleValues: dataForm[];
}

@Component({
    selector: 'app-auto-complete-form',
    templateUrl: './auto-complete-form.component.html',
    styleUrls: ['./auto-complete-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: AutoCompleteFormComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: AutoCompleteFormComponent
        }
    ],
    standalone: false
})
export class AutoCompleteFormComponent implements OnInit, OnChanges, OnDestroy, ControlValueAccessor {
    @ViewChild('autoCompleteInput', {read: MatAutocompleteTrigger})
    autoComplete: MatAutocompleteTrigger | undefined;
    @Input() title: string = '';
    @Input() hiddenClearButton: boolean = true;
    @Input() registerOnChangeKeyValue: 'valueForm' | 'html' | 'traduction' | 'traductions' | 'registerValue' = 'html';

    @Input() items: dataForm[] = [];
    @Input() itemsGroup: GroupDataForm[] = [];
    @Input() showButtons = false;

    @Input() appearance: MatFormFieldAppearance = 'fill';
    @Input() emitFormValue = false;
    @Input() classStyle = '';

    @Input() liveEmitValue = false;


    @Output()
    optionSelected = new EventEmitter<{
        formValues: dataForm | undefined,
        matAuotoComplete: MatAutocompleteSelectedEvent | undefined
    }>();

    form: UntypedFormGroup;
    filteredOptions: Observable<dataForm[]> | undefined;
    filteredOptionsGroup: Observable<GroupDataForm[]> | undefined;
    optionClickedBeforeWrite = false
    scrollEvent = (event: any): void => {
        if (this.autoComplete?.panelOpen) {
            this.autoComplete.updatePosition();
            //this.autoComplete.closePanel();
        }
    };

    constructor(private fb: UntypedFormBuilder,
                private translate: TranslateService) {
        const obj: { [key: string]: string } = {};
        obj["autoComplete"] = '';
        this.form = this.fb.group(obj);
    }

    ngOnInit(): void {
        window.addEventListener('scroll', this.scrollEvent, true);
        if (this.liveEmitValue) {
            const sub = this.form.get('autoComplete')?.valueChanges
                .pipe(debounceTime(300))
                .subscribe(value => {
                    this.emitOptionDigit(value);
                });
            if (sub instanceof Subscription) {
                this.onChangeSubs.push(sub);
            }
            // this.filteredOptions = this.form.get('autoComplete').valueChanges
            //     .pipe(
            //         startWith(''),
            //         map(value => {
            //             return stringIsSet(value) ? this._filter(value) : this.items.slice()
            //         })
            //     );
        }
    }

    ngOnChanges(changes: any): void {
        this.filteredOptions = this.form.get('autoComplete')?.valueChanges
            .pipe(
                startWith(''),
                map((value: string | undefined) => {
                    return this._filter(value)
                })
            );
        this.filteredOptionsGroup = this.form.get('autoComplete')?.valueChanges
            .pipe(
                startWith(''),
                map((value: string | undefined) => {
                    return this._filterGroup(value)
                })
            );
    }

    ngOnDestroy() {
        for (let sub of this.onChangeSubs) {
            sub.unsubscribe();
        }
        window.removeEventListener('scroll', this.scrollEvent);

    }

    private _filter(value: string | undefined): dataForm[] {

        if (arrayIsSet(this.items) && stringIsSet(value)) {
            const filterValue = value.toLowerCase();
            const itemIsSelected = this.items.some(item => {
                return this.getVisuzlizedKey(item).toLowerCase() == filterValue || item.valueForm == value
            })
            let filtered: dataForm[]
            if (this.optionClickedBeforeWrite && itemIsSelected) {
                filtered = this.items
            } else {
                filtered = this.items.filter(data => {
                    return this.getVisuzlizedKey(data).toLowerCase().includes(filterValue)
                })
            }
            this.optionClickedBeforeWrite = false
            return filtered;
        } else {
            this.optionClickedBeforeWrite = false
            return this.items
        }

    }

    private _filterGroup(value: string | undefined): GroupDataForm[] {
        if (arrayIsSet(this.itemsGroup) && stringIsSet(value)) {
            const filterValue = value.toLowerCase();
            const itemIsSelected = this.itemsGroup.some(item => {
                return item.possibleValues.some(pValue => this.getVisuzlizedKey(pValue).toLowerCase() == filterValue || pValue.valueForm == value)
            })
            let filtered: GroupDataForm[]
            if (this.optionClickedBeforeWrite && itemIsSelected) {
                filtered = this.itemsGroup
            } else {
                const itemsGroup = [...this.itemsGroup.map(group => {
                    return {groupName: group.groupName, possibleValues: [...group.possibleValues]}
                })]

                filtered = itemsGroup
                    .filter(item => {
                        item.possibleValues = item.possibleValues.filter(data => {
                            return this.getVisuzlizedKey(data).toLowerCase().includes(filterValue)
                        })
                        return arrayIsSet(item.possibleValues)
                    })
            }
            this.optionClickedBeforeWrite = false
            return filtered;
        } else {
            this.optionClickedBeforeWrite = false
            return this.itemsGroup
        }

    }

    onTouched: Function = () => {
    };

    onChangeSubs: Subscription[] = [];

    registerOnChange(onChange: any) {
        const sub = this.form.get('autoComplete')?.valueChanges
            .pipe(
                map((value) => {
                    if (arrayIsSet(this.items) || arrayIsSet(this.itemsGroup)) {
                        const item = this.getItemFormByValue(value)
                        if (item != null) {
                            return item[this.registerOnChangeKeyValue]
                        }
                    }
                    return value

                })
            )
            .subscribe(onChange);
        if (sub instanceof Subscription) {
            this.onChangeSubs.push(sub);
        }
    }

    registerOnTouched(onTouched: Function) {
        this.onTouched = onTouched;
    }

    getItemFormByValue(value: any): dataForm | undefined {
        let item
        if (arrayIsSet(this.items)) {
            const index = this.items.findIndex(item => item.valueForm == value)
            item = this.items[index]
        } else if (arrayIsSet(this.itemsGroup)) {
            this.itemsGroup.findIndex(itemGroup => {
                const index = itemGroup.possibleValues.findIndex(pValue => pValue.valueForm == value)
                if (index >= 0) {
                    item = itemGroup.possibleValues[index]
                    return true
                } else {
                    return false
                }
            })
        }
        return item
    }

    getItemByValue(value: any, equalsFunction: (item: dataForm, value: any) => boolean): dataForm | undefined {
        let item
        if (arrayIsSet(this.items)) {
            const index = this.items.findIndex(pValue => equalsFunction(pValue, value))
            item = this.items[index]
        } else if (arrayIsSet(this.itemsGroup)) {
            this.itemsGroup.findIndex(itemGroup => {
                const index = itemGroup.possibleValues.findIndex(pValue => equalsFunction(pValue, value))
                if (index >= 0) {
                    item = itemGroup.possibleValues[index]
                    return true
                } else {
                    return false
                }
            })
        }
        return item
    }

    emitOptionSelected(event: MatAutocompleteSelectedEvent) {
        let item = this.getItemFormByValue(event.option.value)
        const value = {
            formValues: item,
            matAuotoComplete: event
        }
        this.optionSelected.emit(value)
    }

    emitOptionDigit(valueInsert: string) {
        const valueDigit = stringIsSet(valueInsert) ? valueInsert.trim() : ''
        const equalsFunctions = (pValue: dataForm, valueDigit: any) => {
            const value = stringIsSet(this.getVisuzlizedKey(pValue)) ? this.getVisuzlizedKey(pValue).toLowerCase() : ''
            return value == valueDigit
        }
        let item = this.getItemByValue(valueDigit, equalsFunctions);

        const value = item != null ? item : {valueForm: valueDigit, html: valueDigit}
        const emitValue = {
            formValues: value,
            matAuotoComplete: undefined
        }
        this.optionSelected.emit(emitValue)
    }

    setDisabledState(disabled: boolean) {
        if (disabled) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }

    writeValue(value: any) {
        if (!isNotNullOrUndefined(value)) {
            this.form.get('autoComplete')?.reset();
        } else if (value) {
            if (stringIsSet(value)) {
                this.form.get('autoComplete')?.setValue(value);
            } if (stringIsSet(value.objectId)) {
                this.form.get('autoComplete')?.setValue(value.objectId);
            } else if (isValidNumber(value)){
                this.form.get('autoComplete')?.setValue(value);
            }
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        // if (!isNotNullOrUndefined(this.form.get('autoComplete')?.validator)) {
        //     this.form.get('autoComplete')?.setValidators(control.validator)
        //     this.form.get('autoComplete')?.updateValueAndValidity()
        // }
        if (this.form.get('autoComplete')?.valid) {
            return null
        } else {
            return this.form.get('autoComplete')?.errors!;
        }
    }

    addControlErrors(allErrors: any, controlName: string) {
        const errors = {...allErrors};
        const controlErrors = this.form.controls[controlName].errors;
        if (controlErrors) {
            errors[controlName] = controlErrors;
        }
        return errors;
    }

    displayFnNumeroQuadro(id: string): string {
        if (arrayIsSet(this.items) || arrayIsSet(this.itemsGroup)) {
            const item = this.getItemFormByValue(id)
            if (item != null) {
                return this.getVisuzlizedKey(item);
            } else {
                return id;
            }
        } else {
            return id;
        }

    }


    resetForm() {
        this.form.get('autoComplete')?.reset();
        this.optionSelected.emit({
            formValues: undefined,
            matAuotoComplete: undefined
        });
    }


    getVisuzlizedKey(item: dataForm) {
        if (item.traductions != null) {
            let keys = '';
            item.traductions.forEach(traduction => {
                keys += this.translate.instant(traduction);
            })
            return keys;
        } else if (stringIsSet(item.traduction)) {
            return this.translate.instant(item.traduction);
        } else {
            return item.html;
        }
    }

    focusOut() {
        this.optionClickedBeforeWrite = true;
    }

    clickbefore() {
        const value = this.form.get('autoComplete')?.value
        let index = this.items.findIndex(item => item.valueForm == value)
        if (index > 0) {
            index = index - 1
        } else if (index == 0) {
            index = this.items.length - 1
        } else {
            index = 0
        }
        const newValue = this.items[index]!
        this.form.get('autoComplete')?.setValue(newValue.valueForm)
        this.optionClickedBeforeWrite = true

    }

    clickNext() {
        const value = this.form.get('autoComplete')?.value
        let index = this.items.findIndex(item => item.valueForm == value)
        if (index >= 0) {
            index = (index + 1) % (this.items.length)
        } else {
            index = 0
        }
        const newValue = this.items[index]!
        this.form.get('autoComplete')?.setValue(newValue.valueForm)
        this.optionClickedBeforeWrite = true
    }

}


